import { z } from 'zod'
import { TimerActuator, TimerActuatorForm } from '../../models/smart-home.model'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { FormInitializerReturnTypeZod, ValidationMessageKeys } from 'src/Configuration/validation'
import { TIME_FORMAT_REGEX } from '../../consts'
import { Days } from '@e3dc-react/shell/Libs/date/types'

export const useTimerActuatorFormInitializer = (actuator: TimerActuator): FormInitializerReturnTypeZod<TimerActuatorForm, TimerActuatorForm> => {
  const { t } = useCustomTranslation()

  const initialValues: TimerActuatorForm = {
    timeOn: actuator.descriptions.timeOn ?? '12:00',
    timeOff: actuator.descriptions.timeOff ?? '16:00',
    week: (actuator.descriptions.week as Days) ?? {
      mo: true,
      tu: true,
      we: true,
      th: true,
      fr: true,
      sa: true,
      su: true,
    },
    auto: actuator.descriptions.auto ?? true,
  }

  const validationSchema = z.object({
    timeOn: z
      .string()
      .transform(value =>
        value
          .replace(':', '')
          .slice(0, 4)
          .replace(/^(\d{2})(\d{0,2})/, '$1:$2')
      )
      .refine(value => value.match(TIME_FORMAT_REGEX) !== null, {
        message: t(ValidationMessageKeys.timeFormat),
      }),
    timeOff: z
      .string()
      .transform(value =>
        value
          .replace(':', '')
          .slice(0, 4)
          .replace(/^(\d{2})(\d{0,2})/, '$1:$2')
      )
      .refine(value => value.match(TIME_FORMAT_REGEX) !== null, {
        message: t(ValidationMessageKeys.timeFormat),
      }),
    week: z.object({
      mo: z.boolean(),
      tu: z.boolean(),
      we: z.boolean(),
      th: z.boolean(),
      fr: z.boolean(),
      sa: z.boolean(),
      su: z.boolean(),
    }),
    auto: z.boolean(),
  })

  return { initialValues, validationSchema }
}
